/**
 * Who may decide a timesheet.
 *
 * The server's rule is "the submitter's manager, or an admin — never the
 * submitter", and it enforces it. The screen was showing Approve and Reject to
 * everybody, so the person who submitted the week saw two controls that fail on
 * click. That is worse than not offering them: it reads as a permissions bug
 * rather than as a rule.
 *
 * This is deliberately about the submitter rather than about a role. A manager
 * fills in their own timesheet too, and when they are looking at their own week
 * they are the submitter — not the approver — however senior they are.
 */
export const idOf = (value) => String(value?._id ?? value ?? "");

export const isOwnTimesheet = (sheet, viewer) => {
  const owner = idOf(sheet?.employee);
  const me = idOf(viewer);
  // Unknown either side is not a match: failing closed here would hide the
  // buttons from a manager whose profile has not loaded yet.
  if (!owner || !me) return false;
  return owner === me;
};

/** A pending week, being looked at by somebody who did not submit it. */
export const canReviewTimesheet = (sheet, viewer) =>
  sheet?.status === "pending" && !isOwnTimesheet(sheet, viewer);
